import React, { useState, useEffect } from "react";
import Header from "../../components/header/Header";
import Sidebar from "../../components/sidebar/Sidebar";
import SingleSiteCard from "../../components/cards/SingleSiteCard";
import { useParams, useNavigate } from "react-router-dom";
import SingleSiteRecordedData from "../../components/recordedData/SingleSiteRecordedData";
import { Icon } from "@iconify/react/dist/iconify.js";
import Cookies from "js-cookie";
import axios from "axios";
import { useLocation } from "react-router-dom";
import TotalCountsCard from "../../components/cards/TotalCountsCard";

const SingleExistingSiteInfo = () => {
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [siteData, setSiteData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { state } = useLocation();
  const [siteBooks, setSiteBooks] = useState(null);
  const { siteId } = state || {};
  const [role, setRole] = useState(null);
  const navigate = useNavigate();
  const { siteName } = useParams();

  const roles = {
    SCANNER_OPERATOR: "scanner-operator",
    PROJECT_COORDINATOR: "coordinator",
  };

  useEffect(() => {
    const fetchSiteData = async () => {
      try {
        const token = Cookies.get("token");
              if (token) {
                const role = Cookies.get("role");
                setRole(role);
              };
        const res = await axios.get(`${baseUrl}/api/sites/${siteId}/approved`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setSiteData(res.data);
      } catch (error) {
        setError("Failed to load site data");
      } finally {
        setLoading(false);
      }
    };

    fetchSiteData();
  }, [siteId, baseUrl]);

  useEffect(() => {
    const fetchSiteBooks = async () => {
      try {
        const token = Cookies.get("token");
        const res = await axios.get(`${baseUrl}/api/sites/${siteId}/books`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setSiteBooks(res.data);
      } catch (error) {
        setError("Failed to load site books");
      } finally {
        setLoading(false);
      }
    };


    fetchSiteBooks();
  }, [siteId, baseUrl]);

  // Convert role name to simpler terms
  const decodedRole = roles[role];

  return (
    <>
      <div className="recorded-data-container supervisor">
        <Sidebar role={decodedRole} />
        <div className="main-content">
          <Header />
          <div
            className="back-button"
            onClick={() => navigate(-1)}
            style={{ cursor: "pointer" }}
          >
            <Icon
              icon="weui:arrow-filled"
              width="12"
              height="24"
              color="var(--menu-color)"
              style={{ transform: "rotate(-180deg)" }}
            />
            <a href="/scanner-operator/dashboard">Back</a>
          </div>
          <div>
            <div className="scanned-info">
              <SingleSiteCard
                siteName={siteName}
                province={siteData?.province}
                district={siteData?.district}
                scannedBooks={siteData?.scannedBooks}
                scannedRecords={siteData?.scannedRecords}
                completionRate={siteData?.completionRate}
              />
              <TotalCountsCard siteId={siteId} />
            </div>
          </div>
          {decodedRole==="scanner-operator" && (
          <SingleSiteRecordedData
            siteName={siteName}
            siteId={siteId}
            province={siteData?.province}
            district={siteData?.district}
            sector={siteData?.sector}
          />)}
        </div>
      </div>
    </>
  );
};

export default SingleExistingSiteInfo;
